import { Rocket, ShieldCheck, Eye, PiggyBank, Layers, Banknote } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Features() {
    const { t } = useTranslation();

    const features = [
        {
            name: t('home.features.items.free.title'),
            description: t('home.features.items.free.description'),
            icon: PiggyBank,
        },
        {
            name: t('home.features.items.maxSecurity.title'),
            description: t('home.features.items.maxSecurity.description'),
            icon: ShieldCheck,
        },
        {
            name: t('home.features.items.transparent.title'),
            description: t('home.features.items.transparent.description'),
            icon: Eye,
        },
        {
            name: t('home.features.items.easySetup.title'),
            description: t('home.features.items.easySetup.description'),
            icon: Rocket,
        },
        {
            name: t('home.features.items.flexible.title'),
            description: t('home.features.items.flexible.description'),
            icon: Layers,
        },
        {
            name: t('home.features.items.onlinePayout.title'),
            description: t('home.features.items.onlinePayout.description'),
            icon: Banknote,
        },
    ];

    return (
        <div className="bg-linear-to-b from-gray-50 to-white py-12 sm:py-16 lg:py-24 dark:from-gray-950 dark:to-gray-900" id="features">
            <div className="mx-auto max-w-7xl w-full px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-headline sm:text-5xl lg:text-balance">
                        {t('home.features.title')}
                    </h2>
                    <p className="mt-6 text-lg leading-relaxed text-paragraph">{t('home.features.description')}</p>
                </div>
                <div className="mx-auto mt-16 max-w-7xl lg:w-full">
                    <dl className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-12 lg:max-w-7xl lg:grid-cols-3 lg:gap-y-16">
                        {features.map((feature) => (
                            <div key={feature.name} className="relative pl-16">
                                <dt className="text-base font-semibold leading-relaxed text-headline">
                                    <div className="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-hs-blue dark:bg-hs-blue-light">
                                        <feature.icon aria-hidden="true" className="size-6 text-white dark:text-white" />
                                    </div>
                                    {feature.name}
                                </dt>
                                <dd className="mt-4 text-base leading-relaxed text-paragraph">{feature.description}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </div>
    );
}
